import React from 'react';
import { SimulationConfig } from '@/types';
import { SectionLabel } from './SectionLabel';
import { SmartInput } from './SmartInput';
import { Toggle } from './Toggle';
import { ControlGroup } from './ControlGroup';

import { CollapsibleSection } from './CollapsibleSection';
import { Square } from 'lucide-react';

interface OutsideColliderSectionProps {
  config: SimulationConfig;
  setConfig: React.Dispatch<React.SetStateAction<SimulationConfig>>;
  isLocked?: boolean;
  minPlan?: string;
  onUpgradeClick?: () => void;
}

export const OutsideColliderSection: React.FC<OutsideColliderSectionProps> = ({ 
    config, setConfig, isLocked, minPlan = "ELITE", onUpgradeClick 
}) => (
  <CollapsibleSection 
    title="Space Boundary" 
    icon={Square} 
    darkMode={config.darkMode} 
    settingKey="outsideCollider"
    isLocked={isLocked}
    lockRequiredPlan={minPlan as any}
    onUpgradeClick={onUpgradeClick}
  >
    <div className="w-full flex flex-col gap-3 mt-4">
      <div className="border border-white/5 p-2 rounded-xl">
          <ControlGroup label="Enabled" settingKey="outsideColliderEnabled" darkMode={config.darkMode}>
            <Toggle active={config.outsideColliderEnabled} onClick={() => setConfig(p => ({...p, outsideColliderEnabled: !p.outsideColliderEnabled}))} />
          </ControlGroup>
      </div>
      
      {config.outsideColliderEnabled && (
          <>
              <div className="border border-white/5 p-2 rounded-xl">
                  <ControlGroup label="Culling Enabled" settingKey="outsideColliderCulling" darkMode={config.darkMode}>
                    <Toggle active={config.outsideColliderCulling} onClick={() => setConfig(p => ({...p, outsideColliderCulling: !p.outsideColliderCulling}))} />
                  </ControlGroup>
              </div>
              {config.outsideColliderCulling && (
                  <SmartInput label="Culling Margin" settingKey="outsideColliderCullingMargin" min={0} max={500} step={5} value={config.outsideColliderCullingMargin} onChange={v => setConfig(p => ({...p, outsideColliderCullingMargin: v}))} darkMode={config.darkMode} />
              )}
              <SmartInput label="Width" settingKey="outsideColliderWidth" min={100} max={4000} step={10} value={config.outsideColliderWidth} onChange={v => setConfig(p => ({...p, outsideColliderWidth: v}))} darkMode={config.darkMode} />
              <SmartInput label="Height" settingKey="outsideColliderHeight" min={100} max={4000} step={10} value={config.outsideColliderHeight} onChange={v => setConfig(p => ({...p, outsideColliderHeight: v}))} darkMode={config.darkMode} />
              <SmartInput label="Scale" settingKey="outsideColliderScale" min={0.1} max={5.0} step={0.1} value={config.outsideColliderScale} onChange={v => setConfig(p => ({...p, outsideColliderScale: v}))} darkMode={config.darkMode} />
              <SmartInput label="Offset X" settingKey="outsideColliderOffsetX" min={-2000} max={2000} step={10} value={config.outsideColliderOffsetX} onChange={v => setConfig(p => ({...p, outsideColliderOffsetX: v}))} darkMode={config.darkMode} />
              <SmartInput label="Offset Y" settingKey="outsideColliderOffsetY" min={-2000} max={2000} step={10} value={config.outsideColliderOffsetY} onChange={v => setConfig(p => ({...p, outsideColliderOffsetY: v}))} darkMode={config.darkMode} />
              <SmartInput label="Bounciness" settingKey="outsideColliderRestitution" min={0} max={2} step={0.1} value={config.outsideColliderRestitution} onChange={v => setConfig(p => ({...p, outsideColliderRestitution: v}))} darkMode={config.darkMode} />
          </>
      )}
    </div>
  </CollapsibleSection>
);
